import Vue from 'vue';

export default {
  state: {
    'user-profile': null,
    'company-profile': null,
    'self-user-profile': null,
    homepage: null
  },
  mutations: {
    ADD_USER_BREADCRUMB(state, name) {
      Vue.set(state, 'user-profile', {
        breadcrumb: [
          {
            title: 'Home',
            url: '/'
          },
          {
            title: 'User Profile'
          },
          {
            title: name,
            active: true
          }
        ]
      });
    },
    ADD_COMPANY_BREADCRUMB(state, name) {
      Vue.set(state, 'company-profile', {
        breadcrumb: [
          {
            title: 'Home',
            url: '/'
          },
          {
            title: 'Company Profile'
          },
          {
            title: name,
            active: true
          }
        ]
      });
    },
    ADD_PERSONAL_PROFILE_BREADCRUMB(state, name) {
      Vue.set(state, 'self-user-profile', {
        breadcrumb: [
          {
            title: 'Home',
            url: '/'
          },
          {
            title: 'My Profile'
          },
          {
            title: name,
            active: true
          }
        ]
      });
    },
    SET_HOME_PAGE_AS_PERSONAL_PROFILE_BREADCRUMB(state, name) {
      Vue.set(state, 'homepage', {
        breadcrumb: [
          {
            title: 'Home',
            url: '/'
          },
          {
            title: 'My Profile'
          },
          {
            title: name,
            active: true
          }
        ]
      });
    }
  },
  actions: {}
};
